import { Check, X } from "lucide-react";

const WhatWeDoSection = () => {
  const whatWeDo = [
    "Establish clear positioning and authority",
    "Create independence from broker portals",
    "Build a modern, mobile-first experience",
    "Make it easy for prospects to reach you",
  ];

  const whatWeDontDo = [
    "SEO retainers or blogging",
    "Ads, funnels, or marketing campaigns",
    "Ongoing marketing services",
    "Full-scale branding retainers",
  ];

  return (
    <section className="section-padding bg-section-alt">
      <div className="container-narrow">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-semibold mb-4 text-primary">
            A Digital Brand Headquarters
          </h2>
          <p className="text-soft text-lg max-w-2xl mx-auto">
            We build websites that serve as the professional foundation of your real estate brand — not just another page on the internet.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-5xl mx-auto">
          {/* What we do */}
          <div className="p-8 bg-card rounded-xl border border-border/50">
            <h3 className="text-xl font-semibold mb-6 text-foreground">
              We do
            </h3>
            <ul className="space-y-4">
              {whatWeDo.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <Check className="w-5 h-5 text-primary flex-shrink-0 mt-0.5" />
                  <span className="text-soft">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* What we don't do */}
          <div className="p-8 bg-card rounded-xl border border-border/50">
            <h3 className="text-xl font-semibold mb-6 text-foreground">
              Clear Boundaries. Better Results.
            </h3>
            <ul className="space-y-4">
              {whatWeDontDo.map((item, index) => (
                <li key={index} className="flex items-start gap-3">
                  <X className="w-5 h-5 text-muted-foreground flex-shrink-0 mt-0.5" />
                  <span className="text-soft">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Craft Signal */}
        <p className="text-center text-sm text-muted-foreground mt-12 max-w-xl mx-auto">
          Specialization, not limitation. We do one thing well.
        </p>
      </div>
    </section>
  );
};

export default WhatWeDoSection;
